import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.color.paper};
  border-radius: 8px;
  margin-top: ${({ theme }) => theme.x4spacePx}px;
  padding: ${({ theme }) => theme.x2spacePx}px;
  a {
    text-decoration: none;
    color: ${({ theme }) => theme.color.noir};
  }
`;

export const Tip = styled.p`
  ${({ theme }) => theme.typography.xSmall}
  margin: 0;
`;

export const EducationalVideoTitle = styled.h3`
  ${({ theme }) => theme.typography.smallStrong}
  margin-top: 10px;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const EducationalVideoContent = styled.p`
  ${({ theme }) => theme.typography.xSmall}
`;

export const VideoLink = styled.p`
  ${({ theme }) => theme.typography.xSmallStrong}
  margin: 0;
`;

export const Image = styled.img`
  border-radius: 6px;
`;
